import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import api from '../services/api';

export const fetchSamples = createAsyncThunk('samples/fetchSamples', async (filters = {}) => {
  const response = await api.get('/samples', { params: filters });
  return response.data;
});

export const createSample = createAsyncThunk('samples/createSample', async (sampleData, { rejectWithValue }) => {
  try {
    const response = await api.post('/samples', sampleData);
    return response.data.sample;
  } catch (error) {
    return rejectWithValue(error.response?.data?.message || error.message || 'Failed to create sample');
  }
});

export const acceptSample = createAsyncThunk('samples/acceptSample', async ({ id, ...acceptData }, { rejectWithValue }) => {
  try {
    const response = await api.post(`/samples/${id}/accept`, acceptData);
    return response.data.sample;
  } catch (error) {
    return rejectWithValue(error.response?.data?.message || error.message || 'Failed to accept sample');
  }
});

export const updateTimestamp = createAsyncThunk('samples/updateTimestamp', async ({ id, ...timestampData }, { rejectWithValue }) => {
  try {
    const response = await api.post(`/samples/${id}/timestamp`, timestampData);
    return response.data.sample;
  } catch (error) {
    return rejectWithValue(error.response?.data?.message || error.message || 'Failed to update timestamp');
  }
});

export const bulkUploadSamples = createAsyncThunk('samples/bulkUploadSamples', async (csvFile, { rejectWithValue }) => {
  try {
    const formData = new FormData();
    formData.append('csvFile', csvFile);
    const response = await api.post('/samples/bulk-upload', formData, {
      headers: { 'Content-Type': 'multipart/form-data' }
    });
    return response.data;
  } catch (error) {
    return rejectWithValue(error.response?.data?.message || error.message || 'Failed to upload CSV');
  }
});



const sampleSlice = createSlice({
  name: 'samples',
  initialState: {
    list: [],
    currentSample: null,
    loading: false,
    error: null,
    pagination: { total: 0, currentPage: 1, totalPages: 1 },
    bulkUploadResult: null
  },
  reducers: {
    clearError: (state) => {
      state.error = null;
    },
    setCurrentSample: (state, action) => {
      state.currentSample = action.payload;
    },
    clearBulkUploadResult: (state) => {
      state.bulkUploadResult = null;
    }
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchSamples.fulfilled, (state, action) => {
        state.loading = false;
        state.list = action.payload.samples;
        state.pagination = {
          total: action.payload.total,
          currentPage: action.payload.currentPage,
          totalPages: action.payload.totalPages
        };
      })
      .addCase(createSample.fulfilled, (state, action) => {
        state.list.unshift(action.payload);
      })
      .addCase(bulkUploadSamples.fulfilled, (state, action) => {
        state.loading = false;
        state.bulkUploadResult = action.payload;
      })
      .addMatcher(
        (action) => action.type.endsWith('/pending'),
        (state) => {
          state.loading = true;
          state.error = null;
        }
      )
      .addMatcher(
        (action) => action.type.endsWith('/rejected'),
        (state, action) => {
          state.loading = false;
          state.error = action.payload || action.error.message;
        }
      );
  }
});

export const { clearError, setCurrentSample, clearBulkUploadResult } = sampleSlice.actions;
export default sampleSlice.reducer;